import { useCallback, useState } from 'react';

export type DecisionAnimationState = 'in' | 'out' | undefined;
type DecisionTarget = 'approve' | 'reject';

const ANIMATION_IN_MS = 600;
const ANIMATION_OUT_MS = 300;

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const useDecisionAnimation = () => {
  const [animation, setAnimation] = useState<{ target: DecisionTarget; state: 'in' | 'out' }>();

  const play = useCallback(async (target: DecisionTarget) => {
    setAnimation({ target, state: 'in' });
    await wait(ANIMATION_IN_MS);
    setAnimation({ target, state: 'out' });
    await wait(ANIMATION_OUT_MS);
  }, []);

  const reset = useCallback(() => setAnimation(undefined), []);

  return {
    approveAnimation: animation?.target === 'approve' ? animation.state : undefined,
    rejectAnimation: animation?.target === 'reject' ? animation.state : undefined,
    play,
    reset,
  };
};
